import { trackGaLink } from '@propertypal/shared/src/services/analytics';
import { Property } from '@propertypal/shared/src/types';
import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import { Text } from '../typography';
import { Badge, Container, Item, ItemContainer, ItemContent } from './PropertyUpgrade.style';

interface Props {
  property: Property;
}

const PropertyUpgrade: FunctionComponent<Props> = ({ property }) => {
  const theme = useTheme();
  return (
    <Container data-testid="property-upgrade">
      <Badge>
        <span>
          Get up to <b>80% more</b> enquiries
        </span>
      </Badge>
      <Item>
        <ItemContainer colour={theme.background}>
          <div>
            <h3>
              Is this <b>your</b> home?
            </h3>
            <ItemContent data-testid="upgrade-text">
              <Text fontSize={17} align="center">
                <b>Prime listings</b> get more <b>VIEWS</b> and <b>ENQUIRIES</b>.
              </Text>
            </ItemContent>
          </div>
          <Link
            href={`/prime?propertyId=${property.pathId}`}
            onClick={trackGaLink('prime_advert_click', 'Side Panel', 'PDP')}
            prefetch={false}
          >
            <Button color={theme.prime.GOLD} maxWidth="220px" containerStyle={{ margin: '0 auto' }}>
              Go {platform.title} Prime
            </Button>
          </Link>
          <Text fontSize={11} align="center" mt={20}>
            *Based on historic performance of previous enhanced formats. Past performance is indicative only and not
            guaranteed. Results may vary.
          </Text>
        </ItemContainer>
      </Item>
    </Container>
  );
};

export default PropertyUpgrade;
